(function () {
  if (window.__pgScriptInitialized) return;
  window.__pgScriptInitialized = true;

  // ─────────────────────────────────────────────
  // PRICE SYSTEM
  // ─────────────────────────────────────────────
  // Every quantity (1–50 Hangers) is now its own real Shopify
  // variant with its own real price (set in Admin to match the
  // client's price list exactly). So there is no calculation here
  // at all — picking a quantity just looks up that exact variant's
  // real id + real price from #pg-variant-map (rendered by Liquid
  // from product.variants). Whatever shows on the page IS the
  // variant that gets added to the cart, so display price and cart
  // price can never diverge.
  const MAX_QTY = 50; // matches the highest "N Hangers" variant

  function fmt(n) {
    return '$' + n.toFixed(2);
  }

  function readVariantMap() {
    const el = document.getElementById('pg-variant-map');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (err) {
      console.error('[PG] Could not parse variant map:', err);
      return {};
    }
  }

  // { colors: ["White", "Black"], color, qty, selected,
  //   variants: { "White": { "1": {id, price, available, media}, ... }, ... } }
  // Products without a Color option have a single color key: "".
  const VARIANT_DATA = readVariantMap();
  const VARIANTS_BY_COLOR = VARIANT_DATA.variants || { '': VARIANT_DATA };
  const COLORS = Array.isArray(VARIANT_DATA.colors) ? VARIANT_DATA.colors : Object.keys(VARIANTS_BY_COLOR);
  let currentColor = COLORS.indexOf(VARIANT_DATA.color) >= 0 ? VARIANT_DATA.color : COLORS[0];
  let VARIANT_MAP = VARIANTS_BY_COLOR[currentColor] || {}; // the selected color's "1"–"50" variants

  // ─────────────────────────────────────────────
  // ELEMENTS
  // ─────────────────────────────────────────────
  const qtyInput        = document.getElementById('qty-input');
  const qtySlider        = document.querySelector('.quantity-control__slider');
  const qtyHidden        = document.getElementById('pg-qty-hidden');
  const unitPriceEl      = document.getElementById('pgUnitPrice');
  const totalPriceEl     = document.getElementById('pgTotalPrice');
  const comparePriceEl   = document.getElementById('pgComparePrice');
  const qsButtons        = document.querySelectorAll('.quickselect__option:not(.quickselect__option--contact)');
  const variantHiddenEl  = document.getElementById('pg-variant-id');
  const atcPriceEl       = document.getElementById('pgAtcPrice');
  const stickyPriceEl    = document.getElementById('pgStickyPrice');
  const stickyMetaEl     = document.getElementById('pgStickyMeta');
  const atcBtn           = document.getElementById('pg-add-to-cart');
  const atcLabelEl       = atcBtn ? atcBtn.querySelector('.add-to-cart__label') : null;
  const stickyBtnEl      = document.getElementById('pgStickyButton');
  const colorBtns        = document.querySelectorAll('.color-picker__option');
  const colorNameEl      = document.getElementById('pgColorName');
  const metaColorEl      = document.getElementById('pgMetaColor');

  // Base = the "1 Hanger" variant's real price. Used only as the
  // reference point for the strikethrough "compare at" price
  // (what it would cost to buy N single hangers at full price).
  function basePrice() {
    return VARIANT_MAP['1'] ? parseFloat(VARIANT_MAP['1'].price) || 0 : 0;
  }
  let BASE_PRICE = basePrice();

  let currentQty = 1;

  // ─────────────────────────────────────────────
  // SLIDER FILL
  // ─────────────────────────────────────────────
  function updateSliderFill() {
    if (!qtySlider) return;
    const min     = parseInt(qtySlider.min, 10);
    const max     = parseInt(qtySlider.max, 10);
    const val     = parseInt(qtySlider.value, 10);
    const percent = ((val - min) / (max - min)) * 100;
    qtySlider.style.background =
      'linear-gradient(to right, #B8922A 0%, #B8922A ' + percent + '%, #f9f5ef ' + percent + '%, #f9f5ef 100%)';
  }

  // ─────────────────────────────────────────────
  // PRICE UPDATE
  // ─────────────────────────────────────────────
  // qty here means "which N-Hangers variant is selected", not a
  // multiplier. We look it up directly — no math on our end. The
  // cart line quantity always stays 1, since one variant already
  // represents the full bundle of N hangers.
  function updatePriceUI(qty) {
    currentQty = Math.max(1, Math.min(MAX_QTY, parseInt(qty) || 1));

    const entry = VARIANT_MAP[String(currentQty)];
    if (!entry) {
      console.warn('[PG] No variant found for quantity', currentQty);
      return;
    }

    if (qtyInput)  qtyInput.value  = currentQty;
    if (qtyHidden) qtyHidden.value = 1; // one line item of the selected N-Hangers variant
    if (variantHiddenEl) variantHiddenEl.value = entry.id;

    // Sold-out color/quantity combination → block adding it
    const soldOut = entry.available === false;
    if (atcBtn) {
      atcBtn.disabled = soldOut;
      atcBtn.classList.toggle('add-to-cart--soldout', soldOut);
    }
    if (atcLabelEl) atcLabelEl.textContent = soldOut ? 'Sold Out' : 'Add To Cart';
    if (stickyBtnEl) {
      stickyBtnEl.disabled = soldOut;
      stickyBtnEl.textContent = soldOut ? 'Sold Out' : 'Add To Cart';
    }

    if (qtySlider) {
      qtySlider.value = currentQty;
      updateSliderFill();
    }

    const total        = parseFloat(entry.price) || 0;
    const compareTotal = BASE_PRICE * currentQty;

    if (unitPriceEl)  unitPriceEl.textContent  = fmt(total);
    if (totalPriceEl) totalPriceEl.textContent = fmt(total);
    if (atcPriceEl)   atcPriceEl.textContent   = fmt(total);
    if (stickyPriceEl) stickyPriceEl.textContent = fmt(total);
    updateBreakdown(total, compareTotal);
    updateShipNote(total);

    if (comparePriceEl) {
      if (compareTotal > total) {
        comparePriceEl.textContent   = fmt(compareTotal);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // quick select active state
    qsButtons.forEach(function (btn) {
      const isActive = parseInt(btn.dataset.qty, 10) === currentQty;
      btn.classList.toggle('quickselect__option--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }
  // ─────────────────────────────────────────────
  // SHIPPING NOTE — mirrors the store's free-shipping tiers (theme
  // settings): which bundle ships free, and which gets faster shipping.
  // ─────────────────────────────────────────────
  const shipNoteEl = document.getElementById('pgShipNote');

  function updateShipNote(total) {
    if (!shipNoteEl) return;
    const freeMin = parseInt(shipNoteEl.dataset.freeMin, 10) || 0;
    const fastMin = parseInt(shipNoteEl.dataset.fastMin, 10) || 0;
    const fastLabel = shipNoteEl.dataset.fastLabel || 'faster';
    const cents = Math.round(total * 100);
    const check = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
    const truck = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';

    let html;
    let free = true;
    if (fastMin > 0 && cents >= fastMin) {
      html = check + '<span><strong>Ships free</strong> with ' + fastLabel + ' US delivery</span>';
    } else if (freeMin === 0 || cents >= freeMin) {
      html = check + '<span><strong>This bundle ships free</strong> in the US</span>';
    } else {
      free = false;
      // smallest quantity of this color whose price unlocks free shipping
      let from = 0;
      for (let n = 1; n <= MAX_QTY; n++) {
        const e = VARIANT_MAP[String(n)];
        if (e && Math.round(parseFloat(e.price) * 100) >= freeMin) { from = n; break; }
      }
      html = truck + '<span>' + (from
        ? '<strong>Free US shipping from ' + from + ' hangers</strong> · shipping calculated at checkout'
        : 'Free US shipping over ' + fmt(freeMin / 100)) + '</span>';
    }
    shipNoteEl.innerHTML = html;
    shipNoteEl.classList.toggle('ship-note--free', free);
  }

  // ─────────────────────────────────────────────
  // PER-HANGER BREAKDOWN
  // Shows what each hanger costs at the current quantity, the total
  // saved vs. buying singles, and a nudge to the next bundle tier
  // (tiers = the Quick Select buttons). All from real variant prices.
  // ─────────────────────────────────────────────
  const eachEl      = document.getElementById('pgEach');
  const saveEl      = document.getElementById('pgSave');
  const nudgeEl     = document.getElementById('pgNudge');
  const qtySummary  = document.getElementById('pgQtySummary');
  const TIERS = Array.prototype.map.call(qsButtons, function (btn) {
    return parseInt(btn.dataset.qty, 10);
  }).filter(Boolean).sort(function (a, b) { return a - b; });

  // Per-hanger price rounded to the cent the same way the cart does
  function perHanger(price, n) {
    return Math.round(Math.round((parseFloat(price) || 0) * 100) / n) / 100;
  }

  function hangersLabel(n) {
    return n + (n === 1 ? ' hanger' : ' hangers');
  }

  function updateBreakdown(total, compareTotal) {
    const each    = perHanger(total, currentQty);
    const saved   = compareTotal - total;
    const pct     = compareTotal > 0 ? Math.round((saved / compareTotal) * 100) : 0;
    const tierBtn = document.querySelector('.quickselect__option[data-qty="' + currentQty + '"][data-name]');

    if (eachEl) {
      eachEl.textContent = fmt(each);
      // At 1 hanger the per-hanger line just repeats the big price
      const row = eachEl.closest('.price-breakdown__row');
      if (row) row.hidden = currentQty === 1;
    }

    if (saveEl) {
      saveEl.hidden = saved < 0.01;
      saveEl.textContent = 'You save ' + fmt(saved) + ' (' + pct + '%)';
    }

    // Next tier nudge — only for in-between amounts (3, 5–9). On a bundle
    // amount the bundle cards already show the next step, so keep it clean.
    const next      = TIERS.filter(function (t) { return t > currentQty; })[0];
    const nextEntry = next ? VARIANT_MAP[String(next)] : null;
    if (nudgeEl) {
      if (nextEntry && !tierBtn) {
        const nextEach = perHanger(nextEntry.price, next);
        const nextBtn  = document.querySelector('.quickselect__option[data-qty="' + next + '"][data-name]');
        nudgeEl.hidden = false;
        nudgeEl.dataset.qty = next;
        nudgeEl.innerHTML =
          '<span class="qty-nudge__text">Add <strong>' + (next - currentQty) + ' more</strong> for ' +
          (nextBtn ? nextBtn.dataset.name : next + ' hangers') + ' · <strong>' + fmt(nextEach) + '</strong> each</span>' +
          '<span class="qty-nudge__cta" aria-hidden="true">Upgrade ' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></span>';
        nudgeEl.setAttribute('aria-label', 'Upgrade to ' + next + ' hangers at ' + fmt(nextEach) + ' each');
      } else {
        nudgeEl.hidden = true;
      }
    }

    // One summary line under the slider (visible while dragging on mobile)
    if (qtySummary) {
      qtySummary.innerHTML =
        '<span><strong>' + hangersLabel(currentQty) + '</strong> · ' + fmt(each) + ' each</span>' +
        (!nextEntry && currentQty > 1
          ? '<span class="qty-summary__save">✓ Best price</span>'
          : saved >= 0.01 ? '<span class="qty-summary__save">Save ' + fmt(saved) + '</span>' : '');
    }

    if (stickyMetaEl) {
      stickyMetaEl.textContent = (tierBtn ? tierBtn.dataset.name + ' · ' : '') +
        (currentColor ? currentColor + ' · ' : '') +
        hangersLabel(currentQty) + ' · ' + fmt(each) + ' each';
    }
  }

  if (nudgeEl) {
    nudgeEl.addEventListener('click', function () {
      const q = parseInt(nudgeEl.dataset.qty, 10);
      if (q) updatePriceUI(q);
    });
  }

  // Expose globally so the homepage bundle section (or any other script)
  // can trigger a price/qty update if it ever runs on the same page.
  window.updatePriceUI = updatePriceUI;

  // ─────────────────────────────────────────────
  // QUICK SELECT LABELS (save % text)
  // ─────────────────────────────────────────────
  // Computed from real variant prices (N-Hangers variant vs. base ×
  // N), not a hardcoded table — stays correct automatically if
  // prices ever change in Shopify Admin. Re-run on every color change
  // so each bundle card shows the selected color's own variant.
  function initQuickSelectLabels() {
    qsButtons.forEach(function (btn) {
      const qtyLabel = parseInt(btn.dataset.qty, 10);
      const entry    = VARIANT_MAP[String(qtyLabel)];
      if (!qtyLabel || !entry) return;

      const price         = parseFloat(entry.price) || 0;
      const compareTotal  = BASE_PRICE * qtyLabel;
      const pct = compareTotal > price
        ? (((compareTotal - price) / compareTotal) * 100).toFixed(0)
        : 0;

      const priceEl = btn.querySelector('.quickselect__price');
      if (priceEl) priceEl.textContent = fmt(price);
      const metaEl = btn.querySelector('.quickselect__meta');
      if (metaEl && qtyLabel > 1) metaEl.textContent = qtyLabel + ' hangers · ' + fmt(perHanger(price, qtyLabel)) + ' each';
      btn.classList.toggle('quickselect__option--soldout', entry.available === false);

      const el = document.getElementById('save-' + qtyLabel);
      if (el) el.textContent = entry.available === false ? 'Sold out' : pct > 0 ? 'Save ' + pct + '%' : '';
    });
  }

  // ─────────────────────────────────────────────
  // COLOR (White / Black)
  // Switches every lookup to that color's variants, keeps the chosen
  // quantity, and shows the variant's image if one is assigned in Admin.
  // ─────────────────────────────────────────────
  function showVariantMedia() {
    const entry   = VARIANT_MAP[String(currentQty)] || VARIANT_MAP['1'];
    const mediaId = entry && entry.media;
    if (!mediaId || !slides) return;
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaId === String(mediaId)) {
        goToSlide(i);
        return;
      }
    }
  }

  function setColor(color, jumpGallery) {
    if (!VARIANTS_BY_COLOR[color]) return;
    currentColor = color;
    VARIANT_MAP  = VARIANTS_BY_COLOR[color];
    BASE_PRICE   = basePrice();

    colorBtns.forEach(function (btn) {
      const isActive = btn.dataset.color === color;
      btn.classList.toggle('color-picker__option--active', isActive);
      btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });
    if (colorNameEl) colorNameEl.textContent = color;
    if (metaColorEl) metaColorEl.textContent = color;

    initQuickSelectLabels();
    updatePriceUI(currentQty);
    if (jumpGallery) showVariantMedia();
  }

  colorBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { setColor(btn.dataset.color, true); });
  });

  // ─────────────────────────────────────────────
  // QUICK SELECT + QTY CONTROLS
  // ─────────────────────────────────────────────
  qsButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      updatePriceUI(btn.dataset.qty);
    });
  });

  var contactBtn = document.querySelector('.quickselect__option--contact');
  if (contactBtn) {
    contactBtn.addEventListener('click', function () {
      window.location.href = '/pages/contact';
    });
  }

  var minusBtn = document.querySelector('.quantity-control__btn--minus');
  var plusBtn  = document.querySelector('.quantity-control__btn--plus');
  if (minusBtn) minusBtn.addEventListener('click', function () { updatePriceUI(currentQty - 1); });
  if (plusBtn)  plusBtn.addEventListener('click',  function () { updatePriceUI(currentQty + 1); });
  if (qtyInput)  qtyInput.addEventListener('input',  function () { updatePriceUI(this.value); });
  if (qtySlider) qtySlider.addEventListener('input', function () { updatePriceUI(this.value); });

  // ─────────────────────────────────────────────
  // CART COUNT UPDATE
  // ─────────────────────────────────────────────
  function updateCartCount(count) {
    // standard data attribute
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    // Horizon bubble badge — hidden when 0
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      el.hidden = (count === 0);
      el.querySelectorAll('[aria-hidden]').forEach(function (inner) {
        inner.textContent = count;
      });
    });
    // Dawn / Horizon uses a <span> inside the cart link with specific class
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  // ─────────────────────────────────────────────
  // OPEN CART DRAWER — multi-strategy
  // ─────────────────────────────────────────────
  function openCartDrawer() {
    // Strategy 1: Horizon custom element method
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    // Strategy 2: cart-drawer-component (some Horizon versions)
    var drawerComponent = document.querySelector('cart-drawer-component');
    if (drawerComponent && typeof drawerComponent.open === 'function') {
      drawerComponent.open();
      return;
    }

    // Strategy 3: click the cart icon to trigger Horizon's own handler
    var cartBtn = document.querySelector('[data-drawer-trigger="cart"], .cart-drawer__toggle, #cart-icon-bubble');
    if (cartBtn) {
      cartBtn.click();
      return;
    }

    // Strategy 4: dispatch the event Horizon listens for
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    window.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  // ─────────────────────────────────────────────
  // CART DRAWER PRICE SYNC
  // (jodi customer drawer-er nijer qty input diye
  // quantity change kore, price box-o update hobe)
  // ─────────────────────────────────────────────
  function initCartDrawerPriceSync() {
    // Shopify standard cart:updated event
    document.addEventListener('cart:updated', function (e) {
      if (!e.detail || !e.detail.cart) return;
      var items = e.detail.cart.items;
      if (items && items.length > 0) {
        updatePriceUI(items[0].quantity);
      }
    });

    // cart drawer quantity input direct watch
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (
        target.closest('cart-drawer-component, cart-drawer') &&
        (target.name === 'updates[]' || target.type === 'number')
      ) {
        updatePriceUI(parseInt(target.value) || 1);
      }
    });
  }

  // ─────────────────────────────────────────────
  // INJECT SECTION HTML
  // Replaces the inner content of the matching
  // element so the custom element shell stays in
  // the DOM (Horizon's JS listeners stay attached)
  // ─────────────────────────────────────────────
  function injectSectionHtml(sectionHtml, sectionId) {
    var parser = new DOMParser();
    var doc    = parser.parseFromString(sectionHtml, 'text/html');

    // Try to find the matching element by id or tag
    var selectors = [
      '#shopify-section-' + sectionId,
      '[id="shopify-section-' + sectionId + '"]',
      'cart-drawer',
      'cart-drawer-component',
      '#cart-drawer',
      '.cart-drawer'
    ];

    var newEl = null;
    var curEl = null;

    for (var i = 0; i < selectors.length; i++) {
      newEl = doc.querySelector(selectors[i]);
      curEl = document.querySelector(selectors[i]);
      if (newEl && curEl) break;
    }

    if (newEl && curEl) {
      // Swap innerHTML so the live element stays in place
      curEl.innerHTML = newEl.innerHTML;
      // Copy across any updated attributes (e.g. aria-expanded)
      Array.from(newEl.attributes).forEach(function (attr) {
        curEl.setAttribute(attr.name, attr.value);
      });
      return true;
    }
    return false;
  }

  // ─────────────────────────────────────────────
  // DISCOVER WHICH SECTION IDS EXIST
  // Horizon wraps sections as #shopify-section-{id}
  // We sniff the page to find what the cart drawer
  // section is actually called.
  // ─────────────────────────────────────────────
  function detectCartSectionIds() {
    var ids = [];
    var candidates = [
      'cart-drawer',
      'cart-notification',
      'cart-icon-bubble',
      'mini-cart',
      'cart-items',
      'cart'
    ];
    candidates.forEach(function (id) {
      if (document.getElementById('shopify-section-' + id)) {
        ids.push(id);
      }
    });
    // fallback: scrape any section containing cart-drawer element
    if (ids.length === 0) {
      var el = document.querySelector('cart-drawer, cart-drawer-component, .cart-drawer');
      if (el) {
        var wrapper = el.closest('[id^="shopify-section-"]');
        if (wrapper) {
          ids.push(wrapper.id.replace('shopify-section-', ''));
        }
      }
    }
    return ids;
  }

  // ─────────────────────────────────────────────
  // ADD TO CART
  // ─────────────────────────────────────────────
  var form = document.getElementById('pg-product-form');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // ── Variant ID: prefer the dedicated hidden field
      // (#pg-variant-id) — falls back to a form field named
      // "id" if the hidden field isn't present on the page.
      var variantEl = document.getElementById('pg-variant-id')
                    || form.querySelector('[name="id"]');
      var variantId = variantEl ? Number(variantEl.value) : null;

      if (!variantId) {
        console.error('[PG] Missing variant ID');
        return;
      }
      if (atcBtn && atcBtn.classList.contains('add-to-cart--soldout')) return;

      var cartBtn = form.querySelector('.add-to-cart');
      if (cartBtn) {
        cartBtn.disabled = true;
        cartBtn.classList.add('add-to-cart--loading', 'loading');
      }

      // Ask for the cart sections' fresh HTML in the same request, so the
      // drawer shows exactly the cart after this add (no stale re-render).
      var sectionsToRequest = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(function (el) { return el.dataset.sectionId; })
        .filter(function (id, i, all) { return all.indexOf(id) === i; });

      // Cart line quantity is always 1 here — currentQty is which
      // "N Hangers" variant is selected, not a multiplier. The
      // variant itself already represents the full bundle of N
      // hangers, so quantity 1 of that variant = N hangers.
      var cartLineQty = qtyHidden ? (parseInt(qtyHidden.value, 10) || 1) : 1;
      var sectionsHtml = null;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id:           variantId,
          quantity:     cartLineQty,
          sections:     sectionsToRequest.join(','),
          sections_url: window.location.pathname
        })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (added) {
        sectionsHtml = added.sections || null;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // Horizon's own "cart:update" event (same shape as CartAddEvent):
        // the drawer / cart page morph in the fresh section HTML, the
        // bubble updates, and dh-cart.js merges same-color bundles.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'pg-product-form',
            data: { source: 'product-form', itemCount: cart.item_count, variantId: String(variantId), sections: sectionsHtml }
          }
        }));
        updateCartCount(cart.item_count);
        initCartDrawerPriceSync();
        // Small tick to let DOM settle, then open drawer
        setTimeout(openCartDrawer, 50);
      })
      .catch(function (err) {
        console.error('[PG] Cart error:', err);
        alert('Something went wrong adding to cart. Please try again.');
      })
      .finally(function () {
        if (cartBtn) {
          cartBtn.disabled = false;
          cartBtn.classList.remove('add-to-cart--loading', 'loading');
        }
      });
    });
  }

  // ─────────────────────────────────────────────
  // GALLERY
  // ─────────────────────────────────────────────
  var thumbBtns = document.querySelectorAll('.product-gallery__thumb');
  var slides    = document.querySelectorAll('.product-gallery__slide');
  var dots      = document.querySelectorAll('.product-gallery__dot');

  function goToSlide(index) {
    slides.forEach(function (s, i) {
      s.classList.toggle('product-gallery__slide--active', i === index);
    });
    thumbBtns.forEach(function (t, i) {
      t.classList.toggle('product-gallery__thumb--active', i === index);
      t.setAttribute('aria-selected', i === index);
      // keep the active thumb visible inside the scrolling thumb column
      if (i === index && t.parentElement) {
        var strip = t.parentElement;
        if (t.offsetTop < strip.scrollTop) {
          strip.scrollTop = t.offsetTop - 3;
        } else if (t.offsetTop + t.offsetHeight > strip.scrollTop + strip.clientHeight) {
          strip.scrollTop = t.offsetTop + t.offsetHeight - strip.clientHeight + 3;
        }
      }
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('product-gallery__dot--active', i === index);
      d.setAttribute('aria-selected', i === index);
    });
  }

  thumbBtns.forEach(function (btn, i) {
    btn.addEventListener('click', function () { goToSlide(i); });
  });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goToSlide(i); });
  });

  // Prev / next arrows + swipe (wraps around at either end)
  function currentSlide() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('product-gallery__slide--active')) return i;
    }
    return 0;
  }

  function stepSlide(dir) {
    if (slides.length < 2) return;
    goToSlide((currentSlide() + dir + slides.length) % slides.length);
  }

  var prevArrow = document.querySelector('.product-gallery__arrow--prev');
  var nextArrow = document.querySelector('.product-gallery__arrow--next');
  if (prevArrow) prevArrow.addEventListener('click', function () { stepSlide(-1); });
  if (nextArrow) nextArrow.addEventListener('click', function () { stepSlide(1); });

  var galleryMain = document.querySelector('.product-gallery__main');
  if (galleryMain) {
    var touchX = null;
    var touchY = null;
    galleryMain.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) stepSlide(dx < 0 ? 1 : -1);
      touchX = touchY = null;
    }, { passive: true });
  }

  // ─────────────────────────────────────────────
  // STICKY ADD TO CART
  // Visible whenever neither the gallery nor the main Add To Cart
  // button is on screen — i.e. while reading the details / choosing a
  // bundle, and after scrolling past the buy box. Clicking it submits
  // the same form (same variant/qty).
  // ─────────────────────────────────────────────
  var stickyBar = document.getElementById('pg-sticky-atc');
  var mainAtc   = document.getElementById('pg-add-to-cart');
  var stickyBtn = document.getElementById('pgStickyButton');
  var galleryEl = document.querySelector('.product-gallery');

  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    var atcInView     = true;
    var atcAbove      = false;
    var galleryInView = true;
    var isMobile      = window.matchMedia('(max-width: 1023px)');

    var syncSticky = function () {
      // Desktop: the gallery column is sticky (always in view), so only
      // show the bar once the main button has scrolled above the viewport.
      var show = isMobile.matches
        ? !atcInView && !galleryInView
        : !atcInView && atcAbove;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    };

    new IntersectionObserver(function (entries) {
      atcInView = entries[0].isIntersecting;
      atcAbove  = entries[0].boundingClientRect.top < 0;
      syncSticky();
    }).observe(mainAtc);

    if (galleryEl) {
      new IntersectionObserver(function (entries) {
        galleryInView = entries[0].isIntersecting;
        syncSticky();
      }).observe(galleryEl);
    } else {
      galleryInView = false;
    }
  }

  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    });
  }

  // ─────────────────────────────────────────────
  // ACCORDION
  // ─────────────────────────────────────────────
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item   = this.closest('.accordion__item');
      var panel  = item.querySelector('.accordion__panel');
      var isOpen = this.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.accordion__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var p = t.closest('.accordion__item').querySelector('.accordion__panel');
        if (p) p.style.maxHeight = null;
      });

      if (!isOpen) {
        this.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  // ─────────────────────────────────────────────
  // ─────────────────────────────────────────────
  function getInitialQty() {
    var params = new URLSearchParams(window.location.search);
    var q = parseInt(params.get('quantity'), 10);
    if (q && q > 0) return q;
    var fromVariant = parseInt(VARIANT_DATA.qty, 10);
    if (fromVariant && fromVariant > 0) return fromVariant;
    return 1;
  }

  currentQty = getInitialQty();
  setColor(currentColor, VARIANT_DATA.selected === true);
  updateSliderFill();

})();
